// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"59e6a19f","453":"93114d02","498":"a7c0765b","648":"8150e76f","703":"09ef5b30","736":"b131c11b","799":"ac4304c3","815":"687a6389","928":"3033c2e2"}[chunkId] + ".chunk.js";
};